
  // SCROLL SUAVE — CTA del hero emocional
  (function() {
    var ctas = document.querySelectorAll('#emoCta');
    for (var i = 0; i < ctas.length; i++) {
      ctas[i].addEventListener('click', function(e) {
        var href = this.getAttribute('href') || '';
        if (href.charAt(0) === '#') {
          var target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
        // Si el href es una URL (configurable en el schema), navega normal.
      });
    }
    // Oculta el placeholder cuando alguna imagen de fondo tenga src
    var bgs = document.querySelectorAll('.hero-emo-bg [data-emo-bg]');
    var ph = document.getElementById('emoPlaceholder');
    for (var j = 0; j < bgs.length; j++) {
      if (bgs[j].getAttribute('src')) {
        bgs[j].style.display = '';
        if (ph) ph.style.display = 'none';
      }
    }


    // Y para la imagen dentro de la tarjeta vino de 3 en 1
    var timg = document.querySelector('[data-t31-img]');
    var tph = document.getElementById('t31Placeholder');
    if (timg && timg.getAttribute('src')) {
      timg.style.display = '';
      if (tph) tph.style.display = 'none';
    }
  })();
  // CONFIGURACIÓN DEL COUNTDOWN — EDITABLE
  

  // --- COMPRAR: todos los botones abren el formulario COD ---
  // Comprobado en la tienda real: la clase _rsi-cod-form-pagefly-... NO hace
  // nada aqui (solo se activa con PageFly). Lo que SI funciona es el boton que
  // la propia app inyecta: #rsi_buy_now_button. Un clic ahi abre su formulario.
  //
  // Asi que nuestros CTA hacen clic en ESE boton. Si la app no esta,
  // caemos en el boton nativo del formulario.
  window.TKcomprar = function(origen) {
    // 1) el boton de la app COD (el que abre el formulario)
    var rsi = document.getElementById('rsi_buy_now_button') ||
              document.querySelector('[id^="rsi_buy_now"], .rsi-custom-button, [class*="rsi-submit"]');
    if (rsi && rsi !== origen && rsi.offsetParent !== null) { rsi.click(); return; }

    // 2) sin la app: el boton real del formulario
    var form = document.querySelector('form[data-type="add-to-cart-form"]') ||
               document.querySelector('form[action*="/cart/add"]');
    if (form) {
      var cand = form.querySelectorAll('button[name="add"], button[type="submit"], .product-form__submit');
      for (var i = 0; i < cand.length; i++) {
        if (cand[i] !== origen && !cand[i].disabled && cand[i].offsetParent !== null) { cand[i].click(); return; }
      }
    }

    // 3) ultimo recurso: llevar a la persona a la oferta
    var destino = document.getElementById('oferta-principal') || form;
    if (destino) destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  // Enganchamos los CTA. La app inyecta su boton tarde, por eso no
  // guardamos referencias: TKcomprar lo busca en el momento del clic.
  (function() {
    var CTA = '.ba-cta-btn, .ec-cta, .sticky-bar-cta';
    var botones = document.querySelectorAll(CTA);
    for (var i = 0; i < botones.length; i++) {
      (function(b) {
        b.addEventListener('click', function(e) {
          e.preventDefault();
          window.TKcomprar(b);
        });
      })(botones[i]);
    }
  })();


  // --- COUNTDOWN TIMER (PERSISTENTE POR NAVEGADOR + IP GUIDE) ---
  // 
  // IMPORTANTE — BLOQUEO POR IP EN SHOPIFY:
  // Este countdown persiste en el navegador del usuario. Para un bloqueo
  // real por IP (que sobreviva borrar caché), necesitas guardar la IP
  // del visitante en un metafield o base de datos externa.
  // 
  // Opción avanzada con Shopify:
  // 1. Usa una app como "Countdown Timer Bar" con bloqueo por IP
  // 2. O crea un endpoint en tu tema que guarde la IP via fetch:
  //    fetch('/apps/countdown?ip=' + visitorIP)
  //
  // Este script usa localStorage + cookies como doble respaldo
  // para máxima persistencia sin servidor.
  (function() {
    var cfg = COUNTDOWN_CONFIG;
    var now = Date.now();
    var endTime = null;

    // Intentar recuperar de localStorage
    try {
      var stored = localStorage.getItem(cfg.storageKey);
      var resetAt = localStorage.getItem(cfg.resetKey);

      if (stored && resetAt) {
        var resetTime = parseInt(resetAt);
        // Si ya pasaron los días de reset, reiniciar
        if (now > resetTime) {
          localStorage.removeItem(cfg.storageKey);
          localStorage.removeItem(cfg.resetKey);
          stored = null;
        }
      }

      if (stored) {
        endTime = parseInt(stored);
      }
    } catch(e) {}

    // Si no hay timer guardado, crear uno nuevo
    if (!endTime) {
      endTime = now + (cfg.hours * 3600000);
      var resetAt = now + (cfg.resetDays * 86400000);
      try {
        localStorage.setItem(cfg.storageKey, endTime.toString());
        localStorage.setItem(cfg.resetKey, resetAt.toString());
        // Cookie como respaldo (sobrevive a borrar localStorage en algunos navegadores)
        document.cookie = cfg.storageKey + '=' + endTime + ';path=/;max-age=' + (cfg.resetDays * 86400);
      } catch(e) {}
    }

    // Si el timer ya expiró pero no ha pasado el reset, mostrar 00:00:00
    function updateCD() {
      var diff = endTime - Date.now();
      if (diff < 0) diff = 0;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var hEl = document.getElementById('cd-hrs');
      var mEl = document.getElementById('cd-min');
      var sEl = document.getElementById('cd-sec');
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    }
    updateCD();
    setInterval(updateCD, 1000);
  })();

  // --- VARIANT SELECTOR + ATC PRICE SYNC ---
  (function() {
    var cards = document.querySelectorAll('.variant-card');
    var saleEl = document.getElementById('atcSalePrice');
    var compareEl = document.getElementById('atcComparePrice');
    var heroSaleEl = document.getElementById('heroPriceSale');
    var heroOriginalEl = document.getElementById('heroPriceOriginal');
    var variantInput = document.getElementById('variant-id-landing');

    function formatPrice(cents) {
      return 'S/ ' + (cents / 100).toFixed(2);
    }

    function syncVariant(card) {
      var variantId = card.getAttribute('data-variant-id');
      var price = card.getAttribute('data-variant-price');
      var compare = card.getAttribute('data-variant-compare');

      if (variantInput && variantId) variantInput.value = variantId;
      if (price) {
        var formatted = formatPrice(parseInt(price));
        if (saleEl) saleEl.textContent = formatted;
        if (heroSaleEl) heroSaleEl.textContent = formatted;
      }
      if (compare) {
        var formattedCompare = formatPrice(parseInt(compare));
        if (compareEl) compareEl.textContent = formattedCompare;
        if (heroOriginalEl) heroOriginalEl.textContent = formattedCompare;
      }
    }

    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        cards.forEach(function(c) { c.classList.remove('selected'); });
        this.classList.add('selected');
        syncVariant(this);
      });
    });

    var initial = document.querySelector('.variant-card.selected');
    if (initial) syncVariant(initial);
  })();

  // --- REVIEWS CAROUSEL ---
  (function() {
    var carousel = document.getElementById('reviewsCarousel');
    if (!carousel) return;
    var cards = carousel.querySelectorAll('.review-card');
    var dots = document.querySelectorAll('.reviews-dot');
    var prevBtn = document.getElementById('revPrev');
    var nextBtn = document.getElementById('revNext');
    if (!prevBtn || !nextBtn) return;
    var current = 0;
    var total = cards.length;

    function scrollToCard(idx) {
      if (idx < 0) idx = total - 1;
      if (idx >= total) idx = 0;
      current = idx;
      // Desplazamos SOLO el carrusel (scrollIntoView movia toda la pagina hacia la derecha).
      var estilo = window.getComputedStyle(carousel);
      var padIzq = parseFloat(estilo.paddingLeft) || 0;
      var destino = carousel.scrollLeft
                  + (cards[idx].getBoundingClientRect().left - carousel.getBoundingClientRect().left)
                  - padIzq;
      var maximo = carousel.scrollWidth - carousel.clientWidth;
      if (destino > maximo) destino = maximo;
      if (destino < 0) destino = 0;
      carousel.scrollTo({ left: destino, behavior: 'smooth' });
      dots.forEach(function(d, i) {
        d.classList.toggle('active', i === current);
      });
    }


    // Al hacer click, el navegador enfoca el boton y desplaza la pagina para mostrarlo.
    // Lo evitamos: bloqueamos el foco automatico del raton (el teclado sigue funcionando).
    [prevBtn, nextBtn].concat(Array.prototype.slice.call(dots)).forEach(function (el) {
      if (!el) return;
      el.addEventListener('mousedown', function (e) { e.preventDefault(); });
    });
    prevBtn.addEventListener('click', function() { scrollToCard(current - 1); });
    nextBtn.addEventListener('click', function() { scrollToCard(current + 1); });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        scrollToCard(parseInt(this.getAttribute('data-idx')));
      });
    });
  })();

  // --- BEFORE / AFTER SLIDER ---
  (function() {
    var container = document.getElementById('baSlider');
    if (!container) return;
    var afterLayer = document.getElementById('baAfter');
    var handle = document.getElementById('baHandle');
    if (!afterLayer || !handle) return;
    var isDragging = false;

    function updateSlider(x) {
      var rect = container.getBoundingClientRect();
      var pos = (x - rect.left) / rect.width;
      pos = Math.max(0.02, Math.min(0.98, pos));
      var pct = pos * 100;
      afterLayer.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }

    container.addEventListener('mousedown', function(e) {
      isDragging = true;
      updateSlider(e.clientX);
      e.preventDefault();
    });

    document.addEventListener('mousemove', function(e) {
      if (isDragging) updateSlider(e.clientX);
    });

    document.addEventListener('mouseup', function() {
      isDragging = false;
    });

    container.addEventListener('touchstart', function(e) {
      isDragging = true;
      updateSlider(e.touches[0].clientX);
    }, { passive: true });

    document.addEventListener('touchmove', function(e) {
      if (isDragging) updateSlider(e.touches[0].clientX);
    }, { passive: true });

    document.addEventListener('touchend', function() {
      isDragging = false;
    });
  })();

  // --- VIDEO CAROUSEL NAV ---
  (function () {
    var grid = document.getElementById('videoCarousel');
    var prevBtn = document.getElementById('vidPrev');
    var nextBtn = document.getElementById('vidNext');
    if (!grid || !prevBtn || !nextBtn) return;

    var scrollAmount = 270;

    // Muestra cada flecha solo si hay algo hacia ese lado.
    function actualizarFlechas() {
      var maximo = grid.scrollWidth - grid.clientWidth;
      var x = grid.scrollLeft;
      var hayIzquierda = x > 4;
      var hayDerecha = x < maximo - 4;
      prevBtn.classList.toggle('nav-oculto', !hayIzquierda);
      nextBtn.classList.toggle('nav-oculto', !hayDerecha);
    }

    prevBtn.addEventListener('click', function () {
      grid.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      grid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    grid.addEventListener('scroll', actualizarFlechas, { passive: true });
    window.addEventListener('resize', actualizarFlechas);
    actualizarFlechas();
    setTimeout(actualizarFlechas, 400);
  })();

  // --- SHIPPING TIMELINE DATES ---
  (function() {
    var meses = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

    function addDays(date, days) {
      var d = new Date(date);
      d.setDate(d.getDate() + days);
      return d;
    }

    function fmt(date) {
      return date.getDate() + ' de ' + meses[date.getMonth()];
    }

    function fmtShort(d1, d2) {
      if (d1.getMonth() === d2.getMonth()) {
        return d1.getDate() + '-' + d2.getDate() + ' de ' + meses[d1.getMonth()];
      } else {
        return d1.getDate() + ' ' + meses[d1.getMonth()] + ' - ' + d2.getDate() + ' ' + meses[d2.getMonth()];
      }
    }

    var today = new Date();
    var d1 = addDays(today, 1);
    var d2 = addDays(today, 2);

    var el1 = document.getElementById('shipDate1');
    var el2 = document.getElementById('shipDate2');
    var el3 = document.getElementById('shipDate3');

    if (el1) el1.textContent = fmt(today);
    if (el2) el2.textContent = fmtShort(today, d1);
    if (el3) el3.textContent = fmtShort(d1, d2);
  })();

  // --- SEQUENTIAL GLOW EFFECT ON SHIPPING ICONS ---
  (function() {
    var timeline = document.getElementById('shippingTimeline');
    if (!timeline) return;
    var icons = timeline.querySelectorAll('.ship-icon');
    if (icons.length < 3) return;
    var current = 0;
    var glowDuration = 800;   // ms each icon stays glowing
    var pauseBetween = 400;   // ms pause between icons
    var pauseEnd = 600;       // ms pause before restarting

    function glowNext() {
      icons.forEach(function(ic) { ic.classList.remove('glow'); });
      icons[current].classList.add('glow');

      setTimeout(function() {
        icons[current].classList.remove('glow');
        current++;
        if (current >= icons.length) {
          current = 0;
          setTimeout(glowNext, pauseEnd);
        } else {
          setTimeout(glowNext, pauseBetween);
        }
      }, glowDuration);
    }

    glowNext();
  })();

  // --- NO MOSTRAR DOS BOTONES DE COMPRA ---
  // Cuando la app COD inyecta su boton (#rsi_buy_now_button), normalmente
  // esconde el nuestro. Pero no siempre lo hace, y entonces quedan los dos:
  // el nuestro arriba (que hace submit y manda al carrito) y el suyo abajo.
  // Aqui lo resolvemos nosotros: si aparece el suyo, escondemos el nuestro.
  (function() {
    var mio = null, oculto = false;

    function botonMio() {
      if (mio && document.body.contains(mio)) return mio;
      var form = document.querySelector('form[data-type="add-to-cart-form"]') ||
                 document.querySelector('form[action*="/cart/add"]');
      if (!form) return null;
      mio = form.querySelector('.atc-button');
      return mio;
    }

    function botonApp() {
      var b = document.getElementById('rsi_buy_now_button') ||
              document.querySelector('[id^="rsi_buy_now"]');
      if (!b) return null;
      // Solo cuenta si de verdad se ve
      if (b.offsetParent === null) return null;
      var r = b.getBoundingClientRect();
      if (r.height < 10) return null;
      return b;
    }

    function revisar() {
      var m = botonMio();
      if (!m) return;
      if (botonApp()) {
        if (!oculto) { m.style.display = 'none'; oculto = true; }
      } else if (oculto) {
        m.style.display = '';
        oculto = false;
      }
    }

    revisar();
    if (window.MutationObserver) {
      var mo = new MutationObserver(function() {
        if (mo._t) clearTimeout(mo._t);
        mo._t = setTimeout(revisar, 200);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
    setTimeout(revisar, 800);
    setTimeout(revisar, 2500);
    setTimeout(revisar, 5000);
  })();

  // --- BARRA FIJA: no apilarse con la de la app de pago contra entrega ---
  // Solo escondemos nuestra barra si aparece OTRA BARRA DE COMPRA fija abajo.
  // Antes bastaba con que algo fuera fixed y ancho, y eso confundia la barra
  // del EDITOR DE SHOPIFY (#PBarNextFrameWrapper) con una barra de Releasit:
  // resultado, nuestra barra desaparecia sin motivo. Ahora exigimos que el
  // elemento contenga de verdad un boton de compra.
  (function() {
    var nuestra = document.getElementById('stickyBar');
    if (!nuestra) return;
    var wa = document.getElementById('waFab');
    var oculta = false;

    // Cosas de Shopify o del navegador que NO son barras de compra
    var IGNORAR = [
      'PBarNextFrameWrapper',      // barra del editor / preview de Shopify
      'admin-bar', 'preview-bar', 'shopify-pc__banner', 'shopify-section-announcement'
    ];

    function esDelSistema(el) {
      for (var i = 0; i < IGNORAR.length; i++) {
        if (el.id === IGNORAR[i]) return true;
        if (el.className && el.className.toString().indexOf(IGNORAR[i]) !== -1) return true;
        if (el.querySelector && el.querySelector('#' + IGNORAR[i])) return true;
      }
      return false;
    }

    function tieneBotonDeCompra(el) {
      // Un boton de la app COD, o cualquier boton cuyo texto hable de comprar
      if (el.querySelector('#rsi_buy_now_button, [id*="rsi_buy"], [class*="rsi-custom-button"]')) return true;
      var botones = el.querySelectorAll('button, a[role="button"]');
      for (var i = 0; i < botones.length; i++) {
        var t = (botones[i].innerText || '').toLowerCase();
        if (/comprar|pedir|carrito|add to cart|buy|ordenar/.test(t)) return true;
      }
      return false;
    }

    function esBarraDeCompraAjena(el) {
      if (!el || el === nuestra || el === wa) return false;
      if (nuestra.contains(el) || el.contains(nuestra)) return false;
      if (wa && (wa.contains(el) || el.contains(wa))) return false;
      if (esDelSistema(el)) return false;
      var s = window.getComputedStyle(el);
      if (s.position !== 'fixed') return false;
      if (s.display === 'none' || s.visibility === 'hidden') return false;
      var r = el.getBoundingClientRect();
      if (r.height < 30 || r.width < window.innerWidth * 0.5) return false;
      if (Math.abs(r.bottom - window.innerHeight) > 8) return false;
      return tieneBotonDeCompra(el);
    }

    function revisar() {
      var todos = document.body.querySelectorAll('div, section, aside, footer');
      for (var i = 0; i < todos.length; i++) {
        if (esBarraDeCompraAjena(todos[i])) {
          if (!oculta) { nuestra.style.display = 'none'; oculta = true; }
          return;
        }
      }
      if (oculta) { nuestra.style.display = ''; oculta = false; }
    }

    revisar();
    if (window.MutationObserver) {
      var mo = new MutationObserver(function() {
        if (mo._t) clearTimeout(mo._t);
        mo._t = setTimeout(revisar, 250);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('resize', revisar);
    setTimeout(revisar, 1500);
    setTimeout(revisar, 4000);
  })();


  // --- GALERÍA DEL PRODUCTO: automática + clic + gestos ---
  (function() {
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.hero-thumbnails .thumb'));
    var dots = Array.prototype.slice.call(document.querySelectorAll('.gallery-dot'));
    var mainImg = document.getElementById('mainProductImage');
    var placeholder = document.getElementById('mainPlaceholder');
    var stage = document.querySelector('.hero-main-image');
    var total = Math.max(thumbs.length, dots.length);
    var current = 0;
    var timer = null;
    var PAUSA = 4000;

    function srcDe(idx) {
      return (thumbs[idx] && thumbs[idx].getAttribute('data-src')) ||
             (dots[idx] && dots[idx].getAttribute('data-src')) || null;
    }

    function mostrar(idx) {
      if (total < 1) return;
      idx = ((idx % total) + total) % total;
      current = idx;
      thumbs.forEach(function(t, k) { t.classList.toggle('active', k === idx); });
      dots.forEach(function(d, k) { d.classList.toggle('active', k === idx); });
      var src = srcDe(idx);
      if (mainImg && src) {
        mainImg.src = src;
        mainImg.style.display = 'block';
        if (placeholder) placeholder.style.display = 'none';
      }
    }

    // El automático se reinicia tras cada interaccion: asi continua
    // desde donde el usuario lo dejo, no vuelve al inicio.
    function arrancar() {
      detener();
      if (total < 2) return;
      timer = setInterval(function() { mostrar(current + 1); }, PAUSA);
    }
    function detener() { if (timer) { clearInterval(timer); timer = null; } }
    function irA(idx) { mostrar(idx); arrancar(); }

    dots.forEach(function(d, k) {
      d.addEventListener('click', function(e) {
        e.preventDefault();
        var i = parseInt(d.getAttribute('data-idx'), 10);
        irA(isNaN(i) ? k : i);
      });
    });

    thumbs.forEach(function(t, k) {
      t.addEventListener('click', function() {
        var i = parseInt(t.getAttribute('data-thumb'), 10);
        irA(isNaN(i) ? k : i);
      });
    });

    if (stage && total > 1) {
      var x0 = null, y0 = null, moviendo = false;
      var MIN = 40;

      stage.addEventListener('touchstart', function(e) {
        if (!e.touches || e.touches.length !== 1) return;
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
        moviendo = false;
        detener();
      }, { passive: true });

      stage.addEventListener('touchmove', function(e) {
        if (x0 === null || !e.touches || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - x0;
        var dy = e.touches[0].clientY - y0;
        // Solo si el gesto es mas horizontal que vertical, para no
        // secuestrar el scroll de la pagina.
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
          moviendo = true;
          if (e.cancelable) e.preventDefault();
        }
      }, { passive: false });

      stage.addEventListener('touchend', function(e) {
        if (x0 === null) { arrancar(); return; }
        var xf = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : x0;
        var dx = xf - x0;
        if (moviendo && Math.abs(dx) >= MIN) {
          mostrar(dx < 0 ? current + 1 : current - 1);
        }
        x0 = null; y0 = null; moviendo = false;
        arrancar();
      }, { passive: true });

      stage.addEventListener('touchcancel', function() {
        x0 = null; y0 = null; moviendo = false; arrancar();
      }, { passive: true });

      stage.addEventListener('mouseenter', detener);
      stage.addEventListener('mouseleave', arrancar);
    }

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) detener(); else arrancar();
    });

    mostrar(0);
    arrancar();
  })();

  // --- STICKY BOTTOM BAR ---
  (function() {
    var stickyBar = document.getElementById('stickyBar');
    var triggerEl = document.querySelector('.section-videos');
    if (!stickyBar || !triggerEl) return;

    function checkSticky() {
      var rect = triggerEl.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.5) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
    }

    window.addEventListener('scroll', checkSticky, { passive: true });
    checkSticky();

    // Sync price with selected variant
    var varCards = document.querySelectorAll('.variant-card');
    var stickyPrice = document.getElementById('stickyPrice');
    var stickyCompare = document.getElementById('stickyCompare');

    function syncStickyPrice(card) {
      var price = card.getAttribute('data-variant-price');
      var compare = card.getAttribute('data-variant-compare');
      if (stickyPrice && price) {
        stickyPrice.textContent = 'S/ ' + (parseInt(price) / 100).toFixed(2);
      }
      if (stickyCompare && compare) {
        stickyCompare.textContent = 'S/ ' + (parseInt(compare) / 100).toFixed(2);
      }
    }

    varCards.forEach(function(card) {
      card.addEventListener('click', function() {
        syncStickyPrice(this);
      });
    });

    var initialVar = document.querySelector('.variant-card.selected');
    if (initialVar) syncStickyPrice(initialVar);
  })();
  // STOCK COUNTDOWN — URGENCIA (editable)
  // CONFIGURACIÓN — EDITABLE:
  

  (function() {
    var cfg = STOCK_CONFIG;
    var heroEl = document.getElementById('heroUrgencyCount');
    var stickyEl = document.getElementById('stickyUrgencyCount');
    var now = Date.now();
    var today = new Date().toDateString();
    var state = null;

    // Recuperar estado persistente
    try {
      var savedDay = localStorage.getItem(cfg.resetKey);
      if (savedDay === today) {
        var saved = localStorage.getItem(cfg.storageKey);
        if (saved) state = JSON.parse(saved);
      } else {
        localStorage.removeItem(cfg.storageKey);
        localStorage.setItem(cfg.resetKey, today);
      }
    } catch(e) {}

    // Si no hay estado, inicializar
    if (!state) {
      state = {
        count: cfg.startUnits,
        nextDrop: now + cfg.fastInterval,
        holdUntil: 0
      };
      saveState();
    }

    function saveState() {
      try {
        localStorage.setItem(cfg.storageKey, JSON.stringify(state));
      } catch(e) {}
    }

    function updateDisplay() {
      var val = Math.max(1, state.count);
      if (heroEl) heroEl.textContent = val;
      if (stickyEl) stickyEl.textContent = val;
    }

    function tick() {
      var now = Date.now();

      // Si está en hold (count = 1), esperar
      if (state.holdUntil > 0 && now < state.holdUntil) {
        updateDisplay();
        return;
      }

      // Si ya pasó el hold, mantener en 1
      if (state.count <= 1) {
        if (state.holdUntil === 0) {
          state.holdUntil = now + cfg.holdAtOne;
          saveState();
        }
        state.count = 1;
        updateDisplay();
        return;
      }

      // Verificar si toca reducir
      if (now >= state.nextDrop) {
        state.count--;
        if (state.count <= 1) {
          state.count = 1;
          state.holdUntil = now + cfg.holdAtOne;
        }
        // Calcular próximo intervalo
        var interval = state.count > cfg.slowThreshold ? cfg.fastInterval : cfg.slowInterval;
        state.nextDrop = now + interval;
        saveState();
      }

      updateDisplay();
    }

    // Ejecutar inmediatamente y cada segundo
    tick();
    setInterval(tick, 1000);
  })();

(function(){
  var tones={
    calida:{bg:'#FFE0AE',glow:'rgba(255,224,174,.6)',label:'Cálida: Para la noche y un look natural.'},
    neutra:{bg:'#FFF3DF',glow:'rgba(255,243,223,.6)',label:'Neutra: Para el día, te ves tal cual saldrás.'},
    blanca:{bg:'#FCFCFF',glow:'rgba(255,255,255,.75)',label:'Blanca: Para el detalle y el maquillaje preciso.'}
  };
  var m=document.getElementById('pqlMirror'), l=document.getElementById('pqlLabel');
  document.querySelectorAll('.pql-ld-btn').forEach(function(b){
    b.addEventListener('click',function(){
      document.querySelectorAll('.pql-ld-btn').forEach(function(x){x.classList.remove('active');});
      b.classList.add('active');
      var t=tones[b.getAttribute('data-t')];
      if(m){m.style.background=t.bg;m.style.boxShadow='0 0 30px 6px '+t.glow;}
      if(l){l.textContent=t.label;}
    });
  });
})();

(function(){
  var stage=document.getElementById('ecStage');
  if(!stage) return;
  document.querySelectorAll('.ec-opt').forEach(function(b){
    b.addEventListener('click',function(){
      document.querySelectorAll('.ec-opt').forEach(function(x){x.classList.remove('active');});
      b.classList.add('active');
      var esRosa = b.getAttribute('data-c')==='rosa';
      stage.classList.toggle('rosa', esRosa);
      // el marcador de texto solo existe si aún no se subieron las fotos
      var ph = stage.querySelector('.ec-ph');
      if (ph) ph.textContent = esRosa ? '[FOTO ROSA]' : '[FOTO NEGRO]';
    });
  });
})();

  // IMAGEN DE ESPECIFICACIONES (schema: specs_image)
  // Muestra la imagen si el usuario subió una en el editor de Shopify.
  // Si no hay imagen: oculta el bloque (no deja hueco vacío).
  // En el preview (sin Liquid) deja el placeholder visible.
  (function(){
    var el = document.getElementById('specImg');
    if (!el) return;
    var src = (el.getAttribute('data-specs-img') || '').trim();
    var unrendered = src.indexOf('{{') !== -1 || src.indexOf('{%') !== -1 || src === '__PREVIEW__';
    if (unrendered) return;            // preview: se queda el placeholder
    if (!src) { el.style.display = 'none'; return; }  // Shopify sin imagen
    var img = document.createElement('img');
    img.src = src;
    img.alt = el.getAttribute('data-specs-alt') || 'Especificaciones del maletín';
    img.loading = 'lazy';
    el.innerHTML = '';
    el.appendChild(img);
  })();

  // WHATSAPP FLOTANTE — se oculta al llegar al FAQ (ya tiene su botón)
  (function(){
    var fab=document.getElementById('waFab'), faq=document.getElementById('faqTitle');
    if(!fab||!faq) return;
    var sticky=document.getElementById('stickyBar');
    function place(){
      // Deja el botón siempre por encima del sticky, midiéndolo de verdad
      var h=0;
      if(sticky){
        var st=window.getComputedStyle(sticky);
        if(st.display!=='none' && st.visibility!=='hidden') h=sticky.offsetHeight;
      }
      document.documentElement.style.setProperty('--wa-bottom', (h ? h+18 : 24)+'px');
    }
    function check(){
      var top=faq.getBoundingClientRect().top;
      fab.classList.toggle('hide', top < window.innerHeight * 0.9);
      place();
    }
    window.addEventListener('scroll', check, {passive:true});
    window.addEventListener('resize', check);
    if(window.ResizeObserver && sticky){ new ResizeObserver(place).observe(sticky); }
    check();
  })();

  // ============================================================
  // VIDEOS — ahorro de datos
  // Los videos NO se descargan al abrir la página. Solo se carga el
  // que la clienta tiene delante, y se pausa al salir de pantalla.
  // En 2G/3G o con "ahorro de datos" activado, no se reproduce nada:
  // se queda la miniatura hasta que ella toque.
  // ============================================================
  (function() {
    var vids = document.querySelectorAll('.section-videos video');
    if (!vids.length) return;
    var cfg = (typeof VIDEO_CONFIG !== 'undefined') ? VIDEO_CONFIG : { autoplay: true, ahorroDatos: true };

    // ¿conexión pobre o ahorro de datos del celular?
    function conexionPobre() {
      if (!cfg.ahorroDatos) return false;
      var con = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!con) return false;
      if (con.saveData) return true;
      var t = con.effectiveType || '';
      return t === 'slow-2g' || t === '2g' || t === '3g';
    }
    var ahorrar = conexionPobre();
    var autoplay = cfg.autoplay && !ahorrar;

    // si no hay autoplay: mostrar controles para que ella decida
    if (!autoplay) {
      for (var i = 0; i < vids.length; i++) vids[i].setAttribute('controls', '');
      return;
    }

    if (!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function(entradas) {
      entradas.forEach(function(e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';   // recién aquí empieza a bajar
          var p = v.play();
          if (p && p.catch) p.catch(function() {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.6 });
    for (var j = 0; j < vids.length; j++) obs.observe(vids[j]);
  })();

  // --- VIDEOS: cargar el embed solo al hacer clic (ahorra ~1MB por video) ---
  (function () {
    document.querySelectorAll('.video-facade').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var src = boton.getAttribute('data-embed');
        if (!src) return;
        var marco = document.createElement('iframe');
        marco.className = 'video-media';
        marco.src = src;
        marco.setAttribute('title', boton.getAttribute('aria-label') || 'Video');
        marco.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        marco.setAttribute('allowfullscreen', '');
        marco.setAttribute('loading', 'lazy');
        boton.replaceWith(marco);
      });
    });
  })();
